import styled from "styled-components";

export const TextMeasure = styled.span`
    opacity: 0;
    pointer-events: none;
    position: absolute;
    white-space: pre; // don't ignore multiple spaces
`;